import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import officina from "src/fonts/officina.woff2";
import { SITE_AUTHENTICATION_ROUTES } from "src/consts/routes";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";
import { authenticationCallback } from "src/api/siteAuthenticationClients";

const Start = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const [getCustomerAccess] = useSessionStorage<string>(
    SESSION_KEYS.MFE_CUSTOMER_ACCESS,
  );

  const [getMicroFrontendDetails] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );

  const initialCall = useCallback(async () => {
    const customerAccess = getCustomerAccess();
    if (!customerAccess) return;
    try {
      const response = await authenticationCallback({
        xIsonCustomerToken: customerAccess,
        searchParams: window.location.search,
      });

      setTimeout(() => {
        if (response.msgId === "success") {
          navigate(SITE_AUTHENTICATION_ROUTES.SUCCESS);
        } else {
          navigate(SITE_AUTHENTICATION_ROUTES.FAILED);
        }
      }, 1000);
    } catch (e) {
      const error = e as Error;
      navigate(SITE_AUTHENTICATION_ROUTES.FAILED + `?msgId=${error.msgId}`);
    }
  }, [getCustomerAccess, navigate]);

  useEffect(() => {
    initialCall();
  }, [initialCall]);

  return (
    <Stack gap={5}>
      <Text
        text={t("page.siteAuthenticationStart.pageTitle", {
          hemProvider: getMicroFrontendDetails()?.hemProvider || "",
        })}
        sx={(theme) => ({
          fontSize: "32px",
          lineHeight: "35px",
          color: theme.palette.mainFont.primary,
          fontFamily: "officina",
          "@font-face": {
            fontFamily: "officina",
            src: `url(${officina}) format("woff2")`,
          },
        })}
      />

      <Text
        text={t("page.siteAuthenticationStart.pageSubTitle", {
          hemProvider: getMicroFrontendDetails()?.hemProvider || "",
        })}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "24px",
          color: theme.palette.mainFont.primary,
        })}
      />

      <PrimaryButton
        fullWidth
        text={t("page.siteAuthenticationStart.nextButton")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "20px",
          maxWidth: { sm: "320px" },
          color: theme.palette.mainFont.primary,
        })}
        isLoading={true}
      />
    </Stack>
  );
};

export default Start;
